import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://b4ae251d8667f09a7baaff32fdfd6d91@o4511195902967808.ingest.de.sentry.io/4511196020801616",
  environment: process.env.NODE_ENV || "development",
  // ── Only enable Sentry on the production domain — preview/dev throws away events ──
  enabled: typeof window !== "undefined" && window.location.hostname === "hosthelp.ai",
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 0,                // Browser tracing disabled: web-vitals crashes older mobile/webview runtimes
  replaysSessionSampleRate: 0.01,     // 1% — was 5%, replay sessions are expensive
  replaysOnErrorSampleRate: 0.25,     // 25% — was 50%, still captures most bugs
  tracePropagationTargets: [
    "localhost",
    /^\//,
    /\.emergentagent\.com/,
    /hosthelp\.ai/,
  ],
  beforeSend(event, hint) {
    const error = hint?.originalException;
    const msg = (error?.message || "").toLowerCase();
    const stack = (error?.stack || "").toLowerCase();
    const status = error?.response?.status;
    // Filter out network errors (user connectivity issues — not our bug)
    if (msg.includes("network error") || msg.includes("failed to fetch") || msg.includes("load failed") ||
        msg.includes("timeout") || msg.includes("timed out") || msg.includes("the operation was aborted") ||
        msg.includes("err_internet_disconnected") || msg.includes("err_network_changed")) {
      return null;
    }
    // Filter out 4xx — user errors, not bugs
    if (status && status >= 400 && status < 500) {
      return null;
    }
    // Filter out 5xx during known outages — we already know about backend hangs
    if (status === 502 || status === 503 || status === 504 || status === 520 || status === 521 || status === 522) {
      return null;
    }
    // Filter out browser quirks
    if (msg.includes("resizeobserver") || msg.includes("non-error promise rejection")) {
      return null;
    }
    // Sentry browser tracing/web-vitals can crash in some mobile webviews with Array.at
    // compatibility errors; tracing is disabled, ignore any queued legacy events.
    if ((msg.includes(".at is not a function") || msg.includes("at is not a function")) && stack.includes("web-vitals")) {
      return null;
    }
    // Filter out chunk loading errors (user on slow network / mid-deploy)
    if (msg.includes("loading chunk") || msg.includes("loading css chunk") ||
        (error?.name || "").toLowerCase().includes("chunkloaderror")) {
      return null;
    }
    return event;
  },
  ignoreErrors: [
    "ResizeObserver loop",
    "Non-Error promise rejection",
    "Network Error",
    "NetworkError when attempting to fetch resource",
    "AbortError",
    "cancelled",
    "ChunkLoadError",
    "Failed to fetch",
    "Load failed",
    "Loading chunk",
    "Loading CSS chunk",
    "this.o.at is not a function",
  ],
});
